import * as React from 'react';

import MessageIcon from '../../../../assets/Message.png';
import { h2Style, pStyle } from '../../../styles';

type HeaderProps = {
  email?: string;
};

export const Header = (props: HeaderProps) => {
  return (
    <>
      <img
        alt=''
        style={{
          width: '50px',
        }}
        src={MessageIcon}
      />
      <h2 style={h2Style}>Check your mail</h2>
      <p style={pStyle}>
        We have sent validation link to your email: {props.email}
      </p>
      <p style={pStyle}>Please check your email and follow the instructions</p>
    </>
  );
};
